import { BaseAtlas } from './BaseAtlas';

/**
 * Auto-generated class for atlas "spritesheets/cards/backs/6_card_back_orange/6_card_back_orange"
 * Contains 1 texture(s)
 */
export class CardsBacks6CardBackOrangeAtlas extends BaseAtlas {
    /**
     * Atlas path
     */
    protected static readonly ATLAS_PATH = 'spritesheets/cards/backs/6_card_back_orange/6_card_back_orange';

    /**
     * List of all available textures in atlas
     */
    protected static readonly TEXTURES = [
        '6_orange.png'
    ] as const;
}
